import React from 'react';

import { getViolationTimeMeta } from '../../../../utils/attendanceViolationHelpers';

const ViolationTimeMeta = ({ violation }) => {
  const { checkIn, checkOut, observant, hrxWorked } = getViolationTimeMeta(violation);

  if (!checkIn && !checkOut && !observant && !hrxWorked) return null;

  return (
    <div className="att-violation-timeline__times">
      {checkIn ? (
        <span
          className="att-violation-timeline__time att-violation-timeline__time--in"
          title="HRX clock-in"
        >
          <i className="bi bi-box-arrow-in-right" aria-hidden />
          <span className="att-violation-timeline__time-label">In</span>
          <span className="att-violation-timeline__time-value">{checkIn}</span>
        </span>
      ) : null}
      {checkOut ? (
        <span
          className="att-violation-timeline__time att-violation-timeline__time--out"
          title="HRX clock-out"
        >
          <i className="bi bi-box-arrow-right" aria-hidden />
          <span className="att-violation-timeline__time-label">Out</span>
          <span className="att-violation-timeline__time-value">{checkOut}</span>
        </span>
      ) : null}
      {observant ? (
        <span
          className="att-violation-timeline__time att-violation-timeline__time--obs"
          title="Observant tracked time"
        >
          <i className="bi bi-display" aria-hidden />
          <span className="att-violation-timeline__time-label">Obs</span>
          <span className="att-violation-timeline__time-value">{observant}</span>
        </span>
      ) : null}
      {hrxWorked ? (
        <span
          className="att-violation-timeline__time att-violation-timeline__time--worked"
          title="HRX worked time"
        >
          <i className="bi bi-clock-history" aria-hidden />
          <span className="att-violation-timeline__time-label">Worked</span>
          <span className="att-violation-timeline__time-value">{hrxWorked}</span>
        </span>
      ) : null}
    </div>
  );
};

export default ViolationTimeMeta;
